<span class="controlWrapper autocompleteWrapper">
  <span class="controlLiner">
    
    <label class="sr-only" [for]="inputId" [id]="inputId + '_label'">
        {{ placeholder || 'Search autocomplete' }}
    </label>

    <span [id]="inputId + '_desc'" class="sr-only">
      Type to search. Use up and down arrows to navigate options. Press Enter to select.
    </span>

 <p-autoComplete
        #primeAutoComplete
        [(ngModel)]="model.text"
        [suggestions]="options"
        (completeMethod)="search($event)"
        (onSelect)="choose($event)"
        (onBlur)="onBlurHandler()"
        [dropdown]="false"
        (onDropdownClick)="onDropdownClick()"

        (onShow)="onPanelShow()"
        (onHide)="onPanelHide()"

        [delay]="200"
        [inputId]="inputId"
        [autoHighlight]="true"
        [forceSelection]="false"
        appendTo="body"
        scrollHeight="250px"
        styleClass="tg-structural-autocomplete"
        panelStyleClass="tg-solid-autocomplete-panel">

        <ng-template let-opt pTemplate="item">
            <div class="ac-item-content">{{ opt | stripHtml }}</div>
        </ng-template>

    </p-autoComplete>

<div aria-live="polite" aria-atomic="true" class="sr-only">
      {{ a11yAnnouncement }}
    </div>

  </span>
</span>